module.exports = __webpack_public_path__ + "img/place26.377bb1c9.jpg";